import { render, staticRenderFns } from "./ProvablyFair.vue?vue&type=template&id=9930080c&"
import script from "./ProvablyFair.vue?vue&type=script&lang=js&"
export * from "./ProvablyFair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports